export default {
  namespaced: true,
  tenants: {
    title: "tenant | tenants",
    title_plural: "Tenants",
    number_of_routers: "Number of routers",
    _name: "name",
    main_image: "Main Image",
    logo_image: "Logo Image",
    image_mobile_app: "Image Mobile App",
    all: "all tenants",
    shared: "shared tenants",
    file_storage: "file storage",
    store:{
      tenant_storage: "Tenant storage",
      storage: "Storage",
      storage_service: "Storage Service",
      assigned_space: "Assigned Space",
      assigned_space_gb: "Assigned Space gb",
      assigned_space_mb: "Assigned Space mb",
      used_space: "Used Space",
      used_space_gb: "Used Space gb",
      used_space_mb: "Used Space mb",
      type: "Type",
      files: "Files",
      assigned_space_min: "Assigned Space Min",
      assigned_space_max: "Assigned Space Max",
      used_space_min: "Used Space Min",
      used_space_max: "Used Space Max",
    },
    file:{
      image: "Image",
      id: "Id",
      name: "Name",
      extension: "Extension",
      size: "Size",
      storage_type: "Storage type",
      directory: "Directory",
      last_access: "Last access",
      size_min: "Size min",
      size_max: "Size max",
      created_from: "Created from",
      created_to: "Created to",
      file_explorer: "File Explorer",
      subdirectories_and_direct_files: "Subdirectories and direct files",
      direct_files: "Direct files",
      files_in_subdirectory: "Files in subdirectory"
    },
    message:{
      add: "Tenant Successfully Added",
      edit: "Tenant Edited Correctly",
      delete: "Tenant Removed Successfully",
      error: "An error occurred",
    }
  },
};
